export default __webpack_public_path__ + "static/media/logo-antoree-v2.766ee881.svg";